import { SubmitHandler, useForm } from "react-hook-form";
import GlobalContext from "../../../contexts/globalContext";
import React, { useEffect, useMemo, useState, useContext, useLayoutEffect, ChangeEvent } from "react";
import Text from "../../../shared/comfama-ui/components/text";
import useSteps from "../../../shared/comfama-ui/hooks/useSteps";
import Stepper from "../../../shared/comfama-ui/components/stepper";
import Layout from "../../../shared/comfama-ui/components/layout/Layout";
import FieldGenerator from "../../../shared/comfama-ui/components/form/field-generator/FieldGenerator";
import maestrasFosfec from "./querys/maestrasFosfec";
import "./FormFosfec.scss";
import sectionFieldsDdlAdapter from "./adapters/sectionFieldsDdlAdapter";
import Loading from "../../atoms/loading/loading";
import ButtonNavigate from "../../../shared/comfama-ui/components/button-navigate/ButtonNavigate";
import Input from "../../../shared/comfama-ui/components/form/input/Input";
import { consultDocuments, getDdlMasters, getBpByTypeDocAndDoc } from "../../../services/fosfec.services";
import Progress from "../../../shared/comfama-ui/components/progress/Progress";
import { porcentageProgress } from "./utils/porcentageProgress";
import { getDocumentalManagementFields } from "./utils/getDocumentalManagementFields";
import Modal from "../../molecules/modal/modal";
import { watcherStatusJob } from "./watchers/watcherStatusJob";
import { watcherAppModality } from "./watchers/watcherAppModality";
import { watcherCompensationFund } from "./watchers/watcherCompensationFund";
import { watcherCity } from "./watchers/watcherCity";
import { watcherRecivedCurrentPension } from "./watchers/watcherRecivedCurrentPension";
import { watcherEmploymentStatus } from "./watchers/watcherEmploymentStatus";
import { watcherHaveDisability } from "./watchers/watcherHaveDisability";
import { watcherEthnic } from "./watchers/watcherEthnic";
import payloadAdapter from "./adapters/payloadAdapter";
import { watcherHasReceivedOutgoingsBenefit } from "./watchers/watcherHasReceivedOutgoingsBenefit";
import { watcherIsAfiliatedPensionFund } from "./watchers/watcherIsAfiliatedPensionFund";
import { watcherSaveForLayoffsFund } from "./watchers/watcherSaveForLayoffsFund";
import ModulateTable from "../../molecules/modulate-table/modulate-table";
import { payLoadFields } from "./types/payLoadFields";
import { saveFormFosfec } from "../../../services/fosfec.services";
import CardInfoDocs from "../../molecules/card-info-docs/cmd-banner/card-info-docs";
import { getDescriptionMessage } from "./utils/getDescriptionMessage";
import { watcherAccountType } from "./watchers/watcherAccountType";
import { watcherDepartment } from "./watchers/watcherDepartment";
import { validateURL } from "./utils/validateURL";
import addressAdapter from "./adapters/addressAdapter";
import modulateTableAdapter from "./adapters/modulateTableAdapter";
import { getDocumentalType } from "./utils/getDocumentalType";
import { getToken } from "../../../services/formServices";
import { validateCity } from "./utils/validateCity";
import { validateHaveDisability } from "./utils/validateHaveDisability";
import ModalGuiaCdc from '../../molecules/modal-guia-cdc/modalGuiaCdc';
import { watcherEmploymentPath } from "./watchers/watcherEmploymentPath";

const FormFosfec = (props: any) => {

    interface IModalContent {
        title: string;
        image: string;
        textButton: string;
        description: string;
        url: string;
        textButtonOpcional? : string;
        urlOpcional?: string;
        openSelf?: boolean;
    }

    type NameFiles= {
        finishedLaborCertificateFileTemp: string;
        idDocumentFileTemp: string;
        noFundPayedDocumentFileTemp: string;
    }

    type dataConsulDocs = {
        campo: string;
        tipoCampo: number;
        valor: string;
    }
    const [modalContent, setModalContent] = useState<IModalContent>();
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [changedNameFiletoShow, setChangedNameFiletoShow] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setErrorBoolean] = useState<boolean>(false);
    const [wizards, setWizards] = useState<any[]>([]);
    const [fields, setFields] = useState<any>([]);
    const [rows, setRows] = useState<number>(1);
    const acceptedFielTypes = ["pdf", "jpeg", "png"];
    const [nameFile, setNameFile] = useState<NameFiles>({
        finishedLaborCertificateFileTemp : "",
        idDocumentFileTemp: "",
        noFundPayedDocumentFileTemp: "",
    });
    const [jwtToken, setTokenJwtToken] = useState<string>("");

    const {
        register,
        handleSubmit,
        watch,
        trigger,
        setValue,
        reset,
        getValues,
        formState,
    } = useForm<payLoadFields>();
    const { errors } = formState;
    useEffect(() => { console.log(error)}, [error])
    //creation of watchers for fields
    const watchAppModality = watch("appModality");
    const watchStatusJob = watch("statusJob");
    const watchDepartment = watch("department");
    const watchCity = watch("city");
    const watchHaveDisability = watch("haveDisability") 
    const watchAccountType = watch("accountType")
    const watchRecivedCurrentPension = watch("currentPension")
    const watchEmploymentPath =  watch("employmentPath")
    const watchCompensationFund = watch("compensationFund")
    const watchEmploymentStatus = watch("employmentStatus")
    const watchEthnic = watch("ethnic")
    const watchHasReceivedOutgoingsBenefit = watch("hasReceivedOutgoingsBenefit")
    const watchIsAfiliatedPensionFund = watch("isAfiliatedPensionFund")
    const watchSaveForLayoffsFund = watch("saveForLayoffsFund")
    const watchHasBeenMembershipedFoundCompensation = watch("hasBeenMembershipedFoundCompensation")
    const [isOpenModalGuiaCdc, setIsOpenModalGuiaCdc] = useState<boolean>(false);

    const Context = useContext(GlobalContext);

    //getting token, Validate gigya account and show popup to login in a specific time 
    useEffect(() => {
        getTokenizer();
        createWizards();
        setIsOpenModal(false)
        if (Context.gigyaContext.gigyaAccount && !initialFields) {
          
            const timer = setTimeout(() => {
                if (!Context.gigyaContext.gigyaAccount) {
                    Context.gigyaContext.loginComfamaId!();
                }
            }, 1500);
            return () => clearTimeout(timer);
        }else if(!Context.gigyaContext.gigyaAccount && fields.length > 0) {
            goToStep(0);
            reset();
            cleanFiles();
        }
    }, [Context.gigyaContext.gigyaAccount]);
    
    const getTokenizer = async () => {
        const tokenizer = await getToken()
        const token = tokenizer.data.data.id_token
        setTokenJwtToken(token)
    }

    const getBPNum = async () => {
        const bp = await getBpByTypeDocAndDoc(getValues("idNumType"),getValues("idNum"),jwtToken)
        setValue("bp", bp.data.data.BP)
    }

    const cleanFiles = () => {
        setValue("idDocumentFileTemp",{})
        setValue("noFundPayedDocumentFileTemp",{})
        setValue("finishedLaborCertificateFileTemp",{})
        setValue("idDocumentFile","")
        setValue("noFundPayedDocumentFile","")
        setValue("publicServiceLaborCertificateFile","")
        setValue("finishedLaborCertificateFile","")
        const copyNameFile = {...nameFile}
        copyNameFile.finishedLaborCertificateFileTemp = "";
        copyNameFile.idDocumentFileTemp = "";
        copyNameFile.noFundPayedDocumentFileTemp = "";
        setNameFile(copyNameFile);
    }
    const addDefaulInteresttOption = (fields: any[], fieldName: string, defaultOption: { id: string, label : string, value : string}): any[]=> {
        return fields.map((field) => {
            if (field.name === fieldName) {
                return {
                    ...field,
                    hidden: true,
                    options: [defaultOption, ...field.options]
                };
            }
            return field;
        });
    };

    const initialFields = useMemo<any>(() => {
        cleanFiles();
        const process = [...props.content.sections];
        (async () => {
            try {
                const maestras = await getDdlMasters();
            process.forEach((section) => {
                //for set aditional fields for dinamics components 
                if(section.idContentful === "1g5hsAWVwXwKgo89rhPYLT") {
                    const fieldIdx = section.fields.length;
                    //adapters for addres
                    const addressFields = addressAdapter(fieldIdx)
                    addressFields.forEach((field: any) => {
                        section.fields.push(field)
                    })
                    // adding new option to the list of interest
                    const defaultOption = {
                        id: "0",
                        label: "Selecciona interés",
                        value: ""
                    };
                    const updatedFields = addDefaulInteresttOption(section.fields, "interest", defaultOption);  
                    section.fields = [...updatedFields];
                  
                }
                if(section.idContentful === "4d5aAGQo79MtBMjIqo8Un3") {
                    const fieldIdx = section.fields.length;
                    const addressFields = modulateTableAdapter(fieldIdx);
                    addressFields.forEach((field: any) => {
                        section.fields.push(field);
                    })
                }
                section.fields?.forEach((field: any) => {
                    sectionFieldsDdlAdapter(field, maestrasFosfec(maestras.data));
                });
            });
            setLoading(false);
            } catch (error) {
                setModalContent({   
                    title: props.content.modalBlockActaullyWorking.title ? props.content.modalBlockActaullyWorking.title : "",
                    image: props.content.modalBlockActaullyWorking.icon ? props.content.modalBlockActaullyWorking.icon : "",
                    description: getDescriptionMessage.servicesUnavailableFailed,
                    textButton: props.content.modalBlockActaullyWorking.primaryButton.title ? props.content.modalBlockActaullyWorking.primaryButton.title : "",
                    url: props.content.modalBlockActaullyWorking.primaryButton.url ? props.content.modalBlockActaullyWorking.primaryButton.url : "",
                    openSelf : true,
                });
                setIsOpenModal(true);
                setErrorBoolean(true);
                setLoading(false); 
            }
            
        })();
        return process;
    }, []);

    const { currentStep, nextStep, prevStep, goToStep } = useSteps({
        stepsNumber: 8
    });

    useEffect(() => {
        setFields(initialFields);
     }, [initialFields]);

     const setFileDocumentIdVisibleAndRequired = () => {
        let process =  [...fields];
            process = process.map((section) => {
                if (section.idContentful !== "6maxdWTbIgpLFmMsh2s8ov") return section
                    let fields = [
                        ...section?.fields.map((field: any) => {
                            if (
                                field.name === "idDocumentFileTemp"
                            ) {
                                return { ...field, hidden: false, required: true};
                            }else if(field.name === "publicServiceLaborCertificateFileTemp"){
                                return setSISEFileHiddenAndNotRequired(field)
                            }
    
                            return field;
                        }),
                    ];
                 return { ...section, fields };
                }); 
                setFields(process);
     }

     const setSISEFileHiddenAndNotRequired = (field : any) =>{
            return { ...field, hidden: true, required: false}
     }

     const toConsultDocuments = async () => {
        try {
        const idNumType = getValues("idNumType")
        const idNum = getValues("idNum")
        const isValueDocumentFileURL = getValues("idDocumentFile") && validateURL(getValues("idDocumentFile").toString());
        if(isValueDocumentFileURL || (!idNum && !idNumType)) return;
        const data :dataConsulDocs[] =[{
                ...getDocumentalManagementFields.NUMERO_DE_IDENTIFICACION,
                valor:idNum
            }
        ]; 
        const documentalTypeorDescription = getDocumentalType(idNumType)
        if(documentalTypeorDescription){
            data.push({
                ...getDocumentalManagementFields.DESCRIPCION_TIPO_DOCUMENTAL,
                valor:documentalTypeorDescription
            })
        }
        const resultConsultDocuments = await consultDocuments(data)
        const documentFileHasURL = resultConsultDocuments.data.moreInfo.toLowerCase() === "true"
        if(documentFileHasURL){
            setValue("idDocumentFile",resultConsultDocuments.data.userMessage) 
         }
        let process =  [...fields];
        process = process.map((section) => {
            if (section.idContentful !== "6maxdWTbIgpLFmMsh2s8ov") return section
                let fields = [
                    ...section?.fields.map((field: any) => {
                        if (
                            field.name === "idDocumentFileTemp"
                        ) {
                            return { ...field, hidden: documentFileHasURL, required: false};
                        }else if(field.name === "publicServiceLaborCertificateFileTemp"){
                            return setSISEFileHiddenAndNotRequired(field)
                        }

                        return field;
                    }),
                ];
             return { ...section, fields };
            }); 
            setFields(process);
        } catch (error) {
            setFileDocumentIdVisibleAndRequired();
        }
      };

    const validNextStep = (fields: any[], idContentful: string) => {
        if(idContentful === "2ar4VQgYuA2dOV9BvDwUSN"){
          toConsultDocuments()
          //validating and getting bp 
          const havePpNum = getValues("bp");
          if(!havePpNum) getBPNum();
        }
        trigger(fields,{ shouldFocus: true }).then((isValid: boolean) => {
            //if it is section Fiels to load
            if (idContentful === "6maxdWTbIgpLFmMsh2s8ov") {
                setChangedNameFiletoShow(!changedNameFiletoShow)
                if(isFilesRequiredLoaded()) nextStep()
            }else {
                if(isValid) nextStep()
            }
        });
    };

    const createWizards = () => {
        let newWizards: any[] = [];
        if(fields) { 
            for (let i = 0; i < fields.length; i++) {
                if (fields[i]) {
                    newWizards.push({
                        description: fields[i].title,
                        idx: i,
                        mainTitle: fields[i].mainTitle,
                        mainDescription: fields[i].mainDescription,
                    });
                }
            }
        }
        setWizards([...newWizards]);
    };
    //to validate size and type for each file selected
    const isValidSizeandType = (fielSize : number, fileType: string) :boolean => {
    let isValidType = false
      acceptedFielTypes.forEach((type) => {   
            if(fileType.includes(type)){
                isValidType = true
            }
        });
    return isValidType && fielSize <= 1572864
    }

    const onChangeFileUpload = (fieldNameTemp: any, e: ChangeEvent<HTMLInputElement>) => {
        if(fieldNameTemp.toLowerCase().includes("file")){
            const copyNameFile = { ...nameFile };
            //delete word temp at the end of the Id for set value base64 to var to send 
            const fieldName =fieldNameTemp.substring(0,fieldNameTemp.length - 4)
            const reader = new FileReader();
            const tempFile = e.target.files?.[0]
            let base64String;
            if (e.target.files && e.target.files.length > 0){
            const isValidFile = isValidSizeandType(e.target.files[0].size, e.target.files[0].type)
            if(!isValidFile)
            { 
                setValue(fieldNameTemp,"")
                setValue(fieldName,"")
                copyNameFile[fieldNameTemp] = fieldName.includes(fieldName) &&  "";
                setNameFile(copyNameFile)
                setModalContent({   
                    title: "¡ADVERTENCIA!",
                    image:  props.content.modalBlockActaullyWorking.icon ? props.content.modalBlockActaullyWorking.icon : "",
                    description: "El archivo que intenta subir supera los 1.5 MB o no es un formato permitido. Por favor, valídelo e inténtelo nuevamente.",
                    textButton: "Salir de la postulación",
                    url: "",
                    textButtonOpcional: "REGRESAR",
                    urlOpcional: ""
                });
                setIsOpenModal(true);
                return
            }
            copyNameFile.idDocumentFileTemp= fieldName.includes("idDocumentFile") ? e.target.files[0].name : nameFile.idDocumentFileTemp;
            copyNameFile.finishedLaborCertificateFileTemp= fieldName.includes("finishedLaborCertificateFile") ? e.target.files[0].name : nameFile.finishedLaborCertificateFileTemp;
            copyNameFile.noFundPayedDocumentFileTemp= fieldName.includes("noFundPayedDocumentFile") ? e.target.files[0].name : nameFile.noFundPayedDocumentFileTemp;
            setNameFile(copyNameFile)
            setValue(fieldNameTemp,tempFile);
         
            reader.readAsDataURL(e.target.files[0]);
            reader.onloadend = () => {
              // Use a regex to remove data url part
              if (reader.result) {
                base64String = String(reader.result).replace("data:", "").replace(/^.+,/, "");
                //set type to value 
                setValue(fieldName,`.${tempFile?.type.split('/')[1]},${base64String}`);
                 }
               }
            } else {
                copyNameFile.idDocumentFileTemp= fieldName.includes("idDocumentFile") ? "" : nameFile.idDocumentFileTemp;
                copyNameFile.finishedLaborCertificateFileTemp= fieldName.includes("finishedLaborCertificateFile") ? "" : nameFile.finishedLaborCertificateFileTemp;
                copyNameFile.noFundPayedDocumentFileTemp= fieldName.includes("noFundPayedDocumentFile") ? "" : nameFile.noFundPayedDocumentFileTemp;
                setValue(fieldNameTemp,"")
                setNameFile(copyNameFile)
            }
        }
    }
    //watchers that will active other fields or list inside them
    useEffect(() => {
        (async () => {
            if(watchStatusJob){
            const isFiledNameSet = getValues("firstName")?.length > 0
            if(!isFiledNameSet && watchStatusJob === "NO"){
            watcherStatusJob(
                watchStatusJob,
                setModalContent,
                setValue,
                setIsOpenModal,
                setErrorBoolean,
                fields,
                Context.gigyaContext,
                props.content.modalBlockActaullyWorking);
            }else if(watchStatusJob === "SÍ"){
                watcherStatusJob(
                    watchStatusJob,
                    setModalContent,
                    setValue,
                    setIsOpenModal,
                    setErrorBoolean,
                    fields,
                    Context.gigyaContext,
                    props.content.modalBlockActaullyWorking);
            }
        }
    }
            )();
    }, [watchStatusJob]);

    useEffect(() => {
        (async () => {
           watcherRecivedCurrentPension(
                watchRecivedCurrentPension,
                setModalContent,
                setValue,
                setIsOpenModal,
                props.content.modalBlockRecivedPension)
            }
            )();
    }, [watchRecivedCurrentPension]);

    useEffect(() => {
        (async () => {
            watcherEmploymentPath(
                watchEmploymentPath,
                setModalContent,
                setValue,
                setIsOpenModal,
                props.content.modalEmploymentPath)
            }
            )();
    },[watchEmploymentPath])

    useEffect(() => {
        (async () => {
               watcherCompensationFund(watchCompensationFund,setModalContent,setValue,setIsOpenModal,props.content.modalBlockDifferentCompensationFund);
            })();
    }, [watchCompensationFund]);
    useEffect(() => {
        (async () => {
               watcherEmploymentStatus(watchEmploymentStatus,setModalContent,setValue,setIsOpenModal,props.content.modalBlockedNotRegisteredSISE);
            })();
    }, [watchEmploymentStatus]);

    useEffect(() => {
        if (!fields.length) return;
        setValue("laborRelationship", "");
        setValue("independentType", "");
        const newFields = watcherAppModality({
            currentStep,
            watcher: watchAppModality,
            fields,
            getValues: getValues
        });
        setFields(newFields);
    }, [watchAppModality]);

    useLayoutEffect(() => {
        if (!fields.length) return;
        setValue("city", "");
        setValue("neighborhood", "");
        const newFields = watcherDepartment({
            currentStep,
            watcher: watchDepartment,
            fields,
            initialFields,
        });
        setFields(newFields);
    }, [watchDepartment]) 

    useLayoutEffect(() => {
        if(!fields.length) return;
        setValue("neighborhood", "");
        const newFields = watcherCity({
            currentStep,
            watcher: watchCity,
            fields,
            initialFields,
            getValues: getValues,
            setValue: setValue
        });
        setFields(newFields);
     }, [watchCity])     

      useEffect(() => {
        if(!fields.length) return;
        setValue("indigenousTown", "");
        setValue("indicateReservation", "");
        const newFields = watcherEthnic({
            currentStep,
            watcher: watchEthnic,
            fields
        });
        setFields(newFields);
       },[watchEthnic])

       useEffect(() => {
        if (!fields.length) return;
        setValue("discapacityCondition", "");
        const newFields = watcherHaveDisability({
            currentStep,
            watcher: watchHaveDisability,
            fields,
            getValues: getValues,
            setValue: setValue
        });
        setFields(newFields);
    }, [watchHaveDisability]);

    useEffect(() => {
        if(!fields.length) return;
        const newFields = watcherAccountType({
            currentStep,
            watcher: watchAccountType,
            fields,
            setValue: setValue
        });
        setFields(newFields);
       },[watchAccountType])

    useLayoutEffect(() => {
        if (!fields.length) return;
        setValue("dateSubsideUnemployment", "");
        const newFields = watcherHasReceivedOutgoingsBenefit({
            currentStep,
            watcher: watchHasReceivedOutgoingsBenefit,
            fields
        });
        setFields(newFields);
    }, [watchHasReceivedOutgoingsBenefit]);

    useEffect(() => {
        if (!fields.length) return;
        setValue("pensionFundAfiliate", "");
        setValue("noPensionPayed", "");
        const newFields = watcherIsAfiliatedPensionFund({
            currentStep,
            watcher: watchIsAfiliatedPensionFund,
            fields
        });
        setFields(newFields);
    }, [watchIsAfiliatedPensionFund]);

    useEffect(() => {
        if (!fields.length) return;
        if(watchSaveForLayoffsFund){
        setValue("afiliationLayoffsFund", "");
        const newFields = watcherSaveForLayoffsFund({
            currentStep,
            watcher: watchSaveForLayoffsFund,
            fields
        });
        setFields(newFields);
    }
    }, [watchSaveForLayoffsFund]);

    useEffect(() => {
        if (!fields.length) return;
        setValue("otherCompensationFund0", "");
        setValue("afiliatedMonths0", "");
        setValue("otherCompensationFund1", "");
        setValue("afiliatedMonths1", "");
    }, [watchHasBeenMembershipedFoundCompensation]);


    const isFilesRequiredLoaded = () :boolean => {
        const fileFinishedLaborCertificate : any  = getValues("finishedLaborCertificateFileTemp");
        const fileIdDocument : any = getValues("idDocumentFileTemp");
        const fileNoFundPayed : any = getValues("noFundPayedDocumentFileTemp");
        const isAfiliatedPensionFund = getValues("isAfiliatedPensionFund");
        const isfileNoFundPayedRequired = isAfiliatedPensionFund === "NO";
        const FileOrNorequiredNoFundpayed = isfileNoFundPayedRequired ? fileNoFundPayed?.name : true 
        const isValueURLOnFileIdDocument = getValues("idDocumentFile") && validateURL(getValues("idDocumentFile").toString());
        const hasDocumentUrlOrFIleLoadedIdDocument = fileIdDocument?.name || isValueURLOnFileIdDocument;
        if(fileFinishedLaborCertificate?.name && FileOrNorequiredNoFundpayed  && hasDocumentUrlOrFIleLoadedIdDocument){
            return true;
        }
        return false;
  }

  useEffect(() => {
    const copyNameFile  = {...nameFile}
    const fileFinishedLaborCertificate : any  = getValues("finishedLaborCertificateFileTemp");
    const fileIdDocument : any = getValues("idDocumentFileTemp");
    copyNameFile.finishedLaborCertificateFileTemp = fileFinishedLaborCertificate? fileFinishedLaborCertificate.name : "";
    copyNameFile.idDocumentFileTemp = fileIdDocument ? fileIdDocument.name : "";
    setNameFile(copyNameFile)
  },[changedNameFiletoShow]);

    if (loading)
    return (
        <div className="loading-container" >
       <React.Fragment>
          <Loading />
       </React.Fragment>
       </div>
    );

    if (!fields.length) return <React.Fragment>Sin campos</React.Fragment>;

    const scrollToTop = () => {
        if(isOpenModal){
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
    }} 

    const onSubmit: SubmitHandler<payLoadFields> = async (data) => {
        try {
            if (currentStep <= 6) return; // cancel submit if isn't last step
            setLoading(true);
            const submitToken = await getToken();
            const payload = payloadAdapter(data);
            const dataSaved = await saveFormFosfec(payload, submitToken.data.data.id_token)
            if(dataSaved.data.status === 200){
                setLoading(false);
                goToStep(0);
                reset();
                cleanFiles();
                setModalContent({   
                    title: props.content.modalConfirmationMessage.title ? props.content.modalConfirmationMessage.title : "",
                    image: props.content.modalConfirmationMessage.icon ? props.content.modalConfirmationMessage.icon : "",
                    description: props.content.modalConfirmationMessage.description ? props.content.modalConfirmationMessage.description : "",
                    textButton: props.content.modalConfirmationMessage.primaryButton.title ? props.content.modalConfirmationMessage.primaryButton.title : "",
                    url: props.content.modalConfirmationMessage.primaryButton.url ? props.content.modalConfirmationMessage.primaryButton.url : "",
                });
                setIsOpenModal(true);
        }else {
            setLoading(false)
            goToStep(0);
            reset();
            cleanFiles();
            setModalContent({   
                title: "¡ADVERTENCIA!",
                image:  props.content.modalBlockActaullyWorking.icon ? props.content.modalBlockActaullyWorking.icon : "",
                description: "Ha ocurrido un error al guardar la postulación, por favor vuelve a intentarlo más tarde.",
                textButton: "SALIR DE LA POSTULACIÓN",
                url:  "",
                openSelf : true,
            });
            setIsOpenModal(true);
        }
        } catch (error) {
            setLoading(false)
            goToStep(0);
            reset();
            cleanFiles();
            setModalContent({   
                title: "¡ADVERTENCIA!",
                image:  props.content.modalBlockActaullyWorking.icon ? props.content.modalBlockActaullyWorking.icon : "",
                description: "Ha ocurrido un error al guardar la postulación, por favor vuelve a intentarlo más tarde.",
                textButton: "SALIR DE LA POSTULACIÓN",
                url:  "",
                openSelf : true,
            });
            setIsOpenModal(true);
            console.log(error);
        }
    };
    //Cierra modal guía para acceder a CDC
    const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModalGuiaCdc((setShow) => !setShow);
	};

    const validatedGuideCdc = () => {
        const checkGuideCdc = localStorage.getItem("guideCdc");
        if (checkGuideCdc !== "true"){
            setIsOpenModalGuiaCdc(true)
        } else {
            Context.gigyaContext.loginComfamaId!();
        }
    }

    return(<>
    <img className='o-form-fosfec__bg' alt="" src={props.content.backgroundImageDesktop} />
        <div style={{ containerType: "inline-size", height: "48rem", position: "relative" }}>
        {!Context.gigyaContext.gigyaAccount ? (
            <div className="o-form-fosfec__unlogin"> 
                <div style={{textAlign: "center", height: "100", marginTop: "8rem"}}>
                    <Text className="o-form-fosfec__main-title" as="h1">
                    Ten en cuenta lo siguiente ...
                    </Text>
                        <Text className="o-form-fosfec__main-subtitle" as="h3">
                        Para realizar la respectiva postulación es necesario que
                            inicies sesión
                        </Text>
                    <Input className="o-form-fosfec__input-Login" type="button" onClick={() => validatedGuideCdc()} value="Iniciar sesión" />
                </div>
                {isOpenModalGuiaCdc && (
                    <ModalGuiaCdc showModal={isOpenModalGuiaCdc} onClose={closeModal}/>
                )}
            </div>
        ) : (
        <div className="o-form-fosfec" >
            {currentStep === 0 ? <>
            <Text className="o-form-fosfec__main-title" as="h1">
                {props.content.mainTitle}
            </Text>
            <Text className="o-form-fosfec__main-subtitle" as="h3">
                {props.content.mainDescription}
            </Text></>:
            <Text className="o-form-fosfec__main-subtitle" as="h3">
            Estado de registro a postulación del Subsidio al Desempleo.
            </Text>}
            <div className="o-form-fosfec__progress">
              <Progress value={porcentageProgress(currentStep,fields)} max="100" porcentage={porcentageProgress(currentStep,fields)} />
            </div>
            <Layout columns="1fr 2fr" gap="2rem">
                <div className="o-form-fosfec__button-navigate">
                    {wizards.map((wizard, idx) => {
                        return (
                            <ButtonNavigate
                                key={idx}
                                number={idx + 1}
                                text={wizard.description}
                                title={wizard.description}
                                active={currentStep === idx}
                                completed={idx < currentStep}
                            />
                        );
                    })}
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Stepper current={currentStep}>
                        {fields.slice(0, 8).map((group: any) => {
                            if(isOpenModal) scrollToTop();
                            //When Contentful id is File section set value to active useEffect Documents
                            const hasBeenMember = getValues("hasBeenMembershipedFoundCompensation")
                            return (
                                <>
                                    <div className="o-form-fosfec__form-container">
                                        <Stepper.Step key={group.id}>
                                            <Text className="o-form-fosfec__title" as="h1">{group.title}</Text>
                                                {group.description.length <= 1 ? (<Text className="o-form-fosfec__description" as="h3">{group.description[0].content[0].value}</Text>): 

                                                group.description.map((content: any, index: any) => {
                                                    return(
                                                    <Text key={index} className={`o-form-fosfec__description_${index}_${group.title.substring(0,3).toLowerCase()}`} as="h3">{content.content[0].value}</Text>
                                                    )
                                                  })}
                                            <Layout columns={group.idContentful === "4d5aAGQo79MtBMjIqo8Un3" || group.idContentful === "6maxdWTbIgpLFmMsh2s8ov" ? "1fr" : "1fr 1fr"}>
                                                <FieldGenerator
                                                    key={group.id}
                                                    fields={group.fields}
                                                    register={register}
                                                    errors={errors}
                                                    setValue={setValue}
                                                    getValues={getValues}
                                                    watch={watch}
                                                    onChange={onChangeFileUpload}
                                                    nameFile={nameFile}
                                                    validateFile={isFilesRequiredLoaded()}
                                                />
                                                {/* If the person has been member, we are going to show the table to select one or two foun compensation */}
                                                {group.idContentful === "4d5aAGQo79MtBMjIqo8Un3" && hasBeenMember === "SÍ" && 
                                                 <ModulateTable content={group.fields} rows={rows} setRows={setRows} register={register} errors={errors}  getValues={getValues} setValue={setValue}/>}
                                                 {group.idContentful === "1g5hsAWVwXwKgo89rhPYLT" && validateCity(watchCity) && watchCity && validateHaveDisability(watchHaveDisability) ? <CardInfoDocs tituloGeneral="Esta información nos permitirá asignarte una Ruta de Aprendizaje de acuerdo a tu interés." getValues={getValues} content={group?.imagenes} infoType="interestQuestion"  /> : ""}
                                                 {group.idContentful === "1g5hsAWVwXwKgo89rhPYLT" && <CardInfoDocs tituloGeneral="Recuerda que debes anexar al final de esta solicitud los siguientes documentos" getValues={getValues} content={group?.imagenes} infoType="attachments" />}
                                            </Layout>
                                        </Stepper.Step>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                        }}
                                    >

                                        <button
                                        className="o-form-fosfec__button-back"
                                            type="button"
                                            onClick={prevStep}
                                        >
                                            Anterior
                                        </button>
                                        <button
                                        className={`o-form-fosfec__continue-button-next${group.idContentful !== "2AbThkRlk7L7M4AD7C266I" ? "" : " gtm_enviar_postulacion_subsidio_desempleo"}`}
                                            type={currentStep < wizards.length - 1? "button" : "submit"}
                                            disabled={group.idContentful === "6maxdWTbIgpLFmMsh2s8ov" &&  !isFilesRequiredLoaded()}
                                            onClick={() =>
                                               currentStep < wizards.length - 1 && validNextStep(
                                                    group.fields?.map(
                                                        (field: any) =>
                                                            field.name
                                                    ), group.idContentful
                                                )
                                            }
                                        >
                                         {group.idContentful !==  "2AbThkRlk7L7M4AD7C266I" ?   "Guardar y continuar →" : "Enviar"}
                                        </button>
                                    </div>
                                </>
                            );
                        })}
                    </Stepper>
                </form>
            </Layout>
        </div>
        )}
        {isOpenModal && (
             <div
             className="o-form-fosfec__modalcontent"
         >
            <Modal
                image={modalContent?.image ? modalContent?.image : ""}
                title={modalContent?.title ? modalContent?.title : ""}
                textButton={modalContent?.textButton ? modalContent?.textButton : ""}
                url={modalContent?.url ? modalContent?.url : ""}
                textButtonOpcional={modalContent?.textButtonOpcional ? modalContent?.textButtonOpcional : ""}
                urlOpcional={modalContent?.urlOpcional ? modalContent?.urlOpcional : ""}
                onClosedModal={() => setIsOpenModal(false)}
                openSelf={modalContent?.openSelf ? modalContent?.openSelf : false}
            >
                <div
                  className="o-form-fosfec__modalcontent__description"
                >
                    {modalContent?.description ? modalContent?.description.toString().split('\n').map((item: any, index: any) => {
                        if(!item) return; 
                        return <><Text key={index}>{index >= 1 ? item.substring(1):item}</Text> <br /> {modalContent?.description.length === index + 1 ? "" : <br />}</>
                    }): ""}
                </div>
            </Modal>
            </div>
        )}
        </div>
    </>
    );
};

export default FormFosfec;
